<template>
  <div class="item_content">
    <div
      class="item_title"
      style="display: flex; justify-content: space-between"
    >
      <div style="width: calc(100% - 75px); overflow: hidden">
        {{ ProductItem.Name }}
      </div>
      <div style="width: 70px; color: red; font-size: 13pt; height: 30px">
        {{ ProductItem.PriceFormat }}
      </div>
    </div>

    <div class="item_content_area" @click="LookProductDetail(ProductItem)">
      <van-image
        class="item_picture"
        fit="contain"
        :style="{ height: imageHeigth + 'px' }"
        :src="ProductItem.CompleteImages"
        aria-readonly=""
        style="border-radius: 10px"
      >
        <template v-slot:error> </template>
      </van-image>

      <div class="item_price_cart">
        <p class="description" v-html="ProductItem.Description"></p>
      </div>
    </div>
    <!-- <div class="item_remark"  v-if="ProductItem.ProductRemark && ProductItem.ProductRemark.length>0 && !ProductItem.IsRemarkRequired"
      style=" min-height: 40px; border-bottom: 1px solid #eee;margin-top: 5px;">
      <van-checkbox-group v-model="ProductRemarkOpts" direction="horizontal">
 
          <van-checkbox  icon-size="15px" shape="square"  style="margin: 5px;" :name="item" v-for="(item,index) in ProductItem.ProductRemark" :key="index"> 
            {{ item.Name }}
          </van-checkbox> 
      </van-checkbox-group> 
    </div> -->
    <div class="item_bottom">
      <div>
        {{ tools.GetLanguageValue("public.app.已点") }}
        {{ ProductItem.PlaceCount }}
      </div>
      <div class="stepper_content">
        <van-stepper
          :disable-plus="DisablePlus"
          v-model="ProductItem.Count"
          :disable-input="true"
          :min="0"
          @minus="MinusCartItem()"
          @plus="GetProduct()"
          v-if="ProductItem.Count > 0"
          :before-change="beforeChange"
        />

        <div
          v-if="ProductItem.Count == 0"
          style="
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex: 1;
            font-size: 18pt;
            color: rgb(29, 29, 29);
            height: 40px;
          "
        >
          <div style="line-height: 40px">
            {{ ProductItem.Count }}
          </div>
          <van-icon
            name="shopping-cart"
            @click="GetProduct()"
            color="rgb(0, 157, 255)"
            size="17pt"
          />
        </div>
      </div>
    </div>
    <div
      style="display: flex; gap: 5px"
      v-if="ProductItem.IngredientJson.length > 0"
    >
      <van-icon @click="IngredientTips" name="info" size="22" color="#F39801" />
      <van-tag
        style="margin: 3px"
        type="danger"
        v-for="(item, index) in ProductItem.IngredientJson"
        :key="index"
      >
        {{ item }}
      </van-tag>
    </div>
  </div>

  <!-- 详细信息 -->
  <van-action-sheet v-model:show="AttributeShow" :title="Product.Name">
    <div class="attribute_content">
      <div style="" :style="{ height: clientHeight + 'px' }">
        <div style="width: 100%; text-align: center">
          <van-swipe :autoplay="3000" lazy-render>
            <van-swipe-item
              v-for="(itemp, index) in Product.Pictures"
              :key="index"
            >
              <img :src="itemp.CompleteImageFormet" style="width: 80%" />
            </van-swipe-item>
          </van-swipe>
        </div>

        <van-col
          span="24"
          style="
            position: absolute;
            bottom: 5px;
            width: 100%;
            text-align: center;
            z-index: 1000000;
          "
        >
          <van-button
            @click="AddShoppingCart()"
            style="width: calc(100% - 50px)"
            color="rgb(0, 157, 255)"
          >
            {{ tools.GetLanguageValue("public.app.添加") }}
          </van-button>
        </van-col>
        <div style="width: 100%; text-align: center">
          {{ Product.Remarks }}
        </div>
        <div v-for="(item, index) in Product.Groups" :key="index">
          <AttributeGroupModule
            :AttributeGroup="item"
            v-model="item.ProductAttributeOpt"
          />
        </div>

        <van-cell
          :title="tools.GetLanguageValue('public.app.要求')"
          v-if="
            Product.ProductRemarkFree.length > 0 ||
            Product.ProductRemarkCollectFree.length > 0
          "
        />

        <div
          style="padding: 10px 20px; border: 1px solid #eee"
          v-if="RemarkVisible"
        >
          <!-- <div style="font-size: 9pt">
            <p v-if="ProductItem.RemarkRequiredMinCount > 0">
              {{ tools.GetLanguageValue("public.app.最少需要选择") }}
              {{ ProductItem.RemarkRequiredMinCount }}
              {{ tools.GetLanguageValue("system.public.个") }}
            </p>

            <p v-if="ProductItem.RemarkRequiredMaxCount > 0">
              {{ tools.GetLanguageValue("public.app.最多可以选择") }}
              {{ ProductItem.RemarkRequiredMaxCount }}
              {{ tools.GetLanguageValue("system.public.个") }}
            </p>
          </div> -->

          <van-checkbox-group
            v-model="ProductRemarkOpts"
            direction="horizontal"
         
          >
            <div
              v-for="productRemarkGroup in Product.ProductRemarkGroup"
              :key="productRemarkGroup"
              style="
                display: flex;
                justify-content: left;
                flex-wrap: wrap;
                width: 100%;
              "
            >
              <p style="min-width: 150px;width: 100%;">
                {{ productRemarkGroup.Name }}
              </p>

              <div
                v-for="item in productRemarkGroup.ProductRemarks"
                :key="item"
                style="
                  margin: 5px;
                  border-radius: 4px;
                  border: 1px solid #ddd;
                  padding: 5px;
                "
              >
                <van-checkbox :name="item">
                  <span style="font-size: 10pt"> {{ item.Name }} </span>
                  <span v-if="item.Price > 0" style="color: red">
                    ({{ item.Price }})
                  </span>
                </van-checkbox>
              </div>
            </div>

          
          </van-checkbox-group>
        </div>

        <div
          style="
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 10px;
          "
          v-if="
            Product.ProductRemarkFree.length > 0 ||
            Product.ProductRemarkCollectFree.length > 0
          "
        >
          <van-button
            v-if="RemarkVisible"
            icon="arrow-up"
            size="small"
            style="width: 120px"
            @click="RemarkVisible = false"
          >
            {{ tools.GetLanguageValue("public.app.隐藏要求") }}
          </van-button>
          <van-button
            v-if="!RemarkVisible"
            icon="arrow-down"
            size="small"
            style="width: 120px"
            @click="RemarkVisible = true"
          >
            {{ tools.GetLanguageValue("public.app.显示要求") }}
          </van-button>
        </div>

        <div
          style="padding: 5px 5px 20px 5px"
          v-html="ProductItem.Description"
        ></div>
      </div>
      <van-row> </van-row>
    </div>
  </van-action-sheet>
</template>
<script>
import axios from "../../commons/AxiosMethod.js";
import tools from "../../commons/tools.js";
import AttributeGroupModule from "../AttributeGroupModule.vue";
import { showToast, showSuccessToast, showFailToast } from "vant";
export default {
  data() {
    return {
      productImg: require("../../assets/正方形logo.png"),
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      Product: {
        Count: 0,
      }, // 商品
      tools: tools,
      AttributeShow: false, // 显示属性面板
      ProductAttributeOpt: [], // 选中属性
      ProductRemarkOpts: [], // 选中备注
      TableId: "", // 桌台ID
      DisablePlus: false,
      IsAddCartDetail: false, // 添加的时候显示详情
      imageHeigth: 200,
      UpdateProduct: () => {},
      RemarkVisible: false,
    };
  },
  name: "App",
  props: {
    ProductItem: {},
    ImageHeigth: 200,
    update: null,
  },
  mounted() {
    this.UpdateProduct = this.update;
    this.Product = this.ProductItem;
    this.imageHeigth = this.ImageHeigth;
    if (this.imageHeigth < 100) {
      this.imageHeigth = 100;
    }
    this.ProductRemarkOpts = [];
    this.TableId = localStorage.getItem("Cache-TableId");

    var addcartDetailed = localStorage.getItem("addcartDetailed");

    this.IsAddCartDetail = addcartDetailed != "yes";

    if (this.Product.IsRemarkRequired) {
      this.RemarkVisible = true;
    }
  },
  components: {
    AttributeGroupModule,
  },
  methods: {
    //弹出提示提示
    IngredientTips() {
      showFailToast(tools.GetLanguageValue("public.app.包含成分"));
    },

    beforeChange(value) {
      console.log(value);
    },
    // 查看详细页面
    LookProductDetail(product) {
      const param = { Id: this.ProductItem.Id };
      axios.apiMethod(
        "/Shopping/Product/GetProduct",
        "get",
        param,
        (result) => {
          this.Product = result.Data;
          this.AttributeShow = true;
        }
      );
    },
    // 获取商品
    GetProduct() {
      const param = { Id: this.ProductItem.Id };
      axios.apiMethod(
        "/Shopping/Product/GetProduct",
        "get",
        param,
        (result) => {
          try {
            if (result.Code == 200) {
              this.Product = result.Data;

              if (result.Data.IsRemarkRequired || result.Data.IsRequired) {
                this.AttributeShow = true;
                return;
              }
              {
                var addcartDetailed = localStorage.getItem("addcartDetailed");

                if (addcartDetailed != "yes") {
                  this.AddShoppingCart();
                  return;
                } else {
                  this.AttributeShow = true;
                }
              }
            } else {
              showToast(result.FullMsg);
            }
          } catch (error) {}
        }
      );
      this.DisablePlus = false;
    },
    // 添加购物车
    AddShoppingCart() {
      const param = {
        ProductId: this.Product.Id,
        Count: 1,
        Remarks: this.Product.Remarks,
        OptProductRemarkItems: this.ProductRemarkOpts,
        ProductRemarkItemsOpt: this.ProductRemarkOpts,
        ProductAttributeGroups: this.Product.Groups,
        TableId: this.TableId,
      };

      this.DisablePlus = true;

      axios.apiMethod(
        "/Store/StoreOrder/AddShoppingCart",
        "post",
        param,
        (result) => {
          try {
            if (result.Data.IsSuccess) {
              showToast(result.Data.Msg);
              this.ProductRemarkOpts = [];
              // this.AttributeShow = false;
              this.ProductItem.Count += 1;
              this.AttributeShow = false;
              tools.GetShoppingCartComplete(this.TableId);
              this.GetShoppingCartByItemId();
            } else {
              showToast(result.Data.Msg);
              this.ProductItem.Count -= 1;
              if (this.ProductItem.Count <= 0) {
                this.ProductItem.Count = 0;
              }
            }
          } catch (error) {}
          this.DisablePlus = false;
        }
      );
    }, // 减少商品
    MinusCartItem() {
      axios.apiMethod(
        "/Store/StoreOrder/CutShoppingCartByProductId",
        "post",
        {
          ProductId: this.Product.Id,
          TableId: this.TableId,
        },
        (result) => {
          if (result.Data.IsSuccess) {
            this.ProductItem.Count = result.Data.Model.Count;
            tools.GetShoppingCartComplete(this.TableId);
            this.GetShoppingCartByItemId();
            return;
          }
          showToast(result.Data.Msg);
        },
        (e) => {}
      );
    },
    //获取购物车行的数据
    GetShoppingCartByItemId() {
      const param = { productId: this.ProductItem.Id, tableId: this.TableId };
      axios.apiMethod(
        "/Store/StoreOrder/GetShoppingCartByItemId",
        "get",
        param,
        (result) => {
          this.ProductItem.Count = result.Model.Count;
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.product_remark {
  padding: 5px 22px;
  font-size: 7pt;
  border: 1px solid #eee;
  margin: 3px;
  border-radius: 5px;
}

.item_content {
  background-color: #fff;
  border-radius: 15px;
  padding: 5px;
  margin-top: 5px;

  .pricture_name {
    color: #333;
    font-size: 11pt;
    width: calc(100% - 70px);
    height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-weight: 500;
    margin-left: 10px;
  }

  .item_content_area {
    margin: 0 auto;
    margin-top: 10px;
    width: calc(100% - 20px);

    border-radius: 5px;
    display: flex;
    border-bottom: 1px dashed rgb(166, 163, 163);

    .item_picture {
      background-color: #fff;
      width: 125px;
      border-radius: 15px;
    }

    .item_price_cart {
      margin: 0 auto;
      font-size: 9pt;
      width: calc(100% - 135px);
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      position: relative;

      .description {
        width: 100%;
        padding: 0px 5px;
        overflow: hidden;
        height: 46px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: normal;
      }

      .item_price_cart_bottom {
        position: absolute;
        height: 40px;
        bottom: 0px;
        right: 0px;
        line-height: 40px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .item_price {
          width: 60px;
          line-height: 40px;
          color: #333;
          font-family: "Titillium Web", Arial, sans-serif;
          font-size: 13pt;
        }
      }
    }
  }

  .item_content_chengfen {
    height: 20px;
    display: flex;

    .items {
      width: 20px;
      height: 20px;
      border: 1px solid #333;
      margin-left: 5px;
      text-align: center;
    }
  }
}

.stepper_content {
  display: flex;
  width: 100px;
  text-align: right;
  height: 30px;
  line-height: 40px;
}

.item_bottom {
  display: flex;
  justify-content: space-between;
  padding: 3px 10px;
}
</style>
